<form [formGroup]="formInvoiceRejection">
  <div class="mb-3">
    <div class="title">{{ optionsLabel }}</div>
    <p-multiSelect
      appendTo="body"
      name="invoiceRejectionList"
      placeholder="Select reason for rejecting the invoice"
      [maxSelectedLabels]="2"
      [options]="optionsList"
      optionLabel="rejectReasonDescription"
      formControlName="invoiceRejectionReason"></p-multiSelect>
  </div>
  @if (showTextArea) {
    <div class="mb-3">
      <div class="title">{{ textareaLabel }}</div>
      <div>
        <textarea
          pTextarea
          formControlName="additionalNotesRejectionReason"
          class="additional-notes p-1"
          [placeholder]="textareaPlaceholder"
          rows="5"
          name="additionalNotes"
          maxlength="250"
          aria-label="additionalnotes"></textarea>
        <small class="form-text text-muted">
          <code>{{
            formInvoiceRejection.controls['additionalNotesRejectionReason']
              .value
              ? formInvoiceRejection.controls['additionalNotesRejectionReason']
                  .value.length
              : 0
          }}</code>
          of <code>250</code> characters
        </small>
      </div>
    </div>
  }
  <button
    type="button"
    pTooltip="Ok"
    [disabled]="!invoiceDenyButtonEnable"
    tooltipPosition="top"
    class="ui-button-info btnpad btnmr button-ok"
    pButton
    (click)="confirmClcik()">
    Ok
  </button>
  <button
    type="button"
    pTooltip="Cancel"
    tooltipPosition="top"
    class="ui-button-info btnpad btnmr button-cancel"
    pButton
    (click)="cancelClick()">
    Cancel
  </button>
</form>
